import { orderShowModal } from "./orderShowModal";
import { useCallback, useState } from "react";

type UseHomeModalsReturn = {
  showActiveModal: number;
  handleNextModal: () => void;
};

const useHomeModals = (): UseHomeModalsReturn => {
  const [showActiveModal, setShowActiveModal] = useState(1);

  const handleNextModal = useCallback(() => {
    const idx = orderShowModal.findIndex(
      (order) => order.id === showActiveModal + 1
    );
    if (idx > -1) setShowActiveModal(showActiveModal + 1);
  }, [showActiveModal]);

  return { showActiveModal, handleNextModal };
};
export default useHomeModals;
